import { useContext } from 'react';

import { ResponsiveContext } from 'components/app/AppContext';

export const useResponsive = () => {
  return useContext(ResponsiveContext);
};
